//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

export default {
  components: {
    VuePlyr,
  },
  props: {
    firstName: {
      type: String,
      default: '',
    },
    implantType: {
      type: Array,
      default() {},
    },
    videoLink: {
      type: String,
      default: null,
    },
    videoThumbnail: {
      type: Object,
      default() {
        return { url: require('@/assets/img/thumb-placeholder.png') }
      },
    },
    avatarForVideo: {
      type: Object,
      default() {},
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      playerOptions: {
        controls: `
        <div class="plyr__controls__item plyr__volume"><button type="button" class="plyr__control" data-plyr="mute"><svg class="icon--pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__sr-only">Unmute</span><span class="label--not-pressed plyr__sr-only">Mute</span></button></div>
        <button class="plyr__controls__item plyr__control play-centered" type="button" data-plyr="play" aria-label="Play"><svg class="icon--pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__sr-only">Pause</span><span class="label--not-pressed plyr__sr-only">Play</span></button>
        <div class="overlay-pause" style="background-image: url('${
          this.videoThumbnail
            ? this.videoThumbnail.url
            : require('@/assets/img/thumb-placeholder.png')
        }')"></div>
        
        <div class="mentor-infos">
          <div class="avatar">
            <img
              src="${
                this.avatarForVideo
                  ? this.avatarForVideo.url
                  : require('@/assets/img/avatar-mentor-square.svg')
              }"
              alt=""
            />
          </div>
          <div class="content">
            <h3>${this.firstName && this.firstName}</h3>
            <p>${
              this.implantType &&
              this.$translation(`implantType.${this.implantType[0]}`)
            }</p>
          </div>
          <button class="mentor-button button button--variant-primary">
            ${this.$translation('button.getInTouch')}
          </button>
        </div>
        <div class="plyr__controls"><button class="plyr__controls__item plyr__control" type="button" data-plyr="play" aria-label="Play"><svg class="icon--pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__sr-only">Pause</span><span class="label--not-pressed plyr__sr-only">Play</span></button><div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" autocomplete="off" role="slider" aria-label="Seek" aria-valuemin="0" aria-valuemax="187" aria-valuenow="3.280073036239624" id="plyr-seek-8126" aria-valuetext="00:03 of 03:07" style="--value: 1.7500000000000002%;" seek-value="70.73270234986946"><progress class="plyr__progress__buffer" min="0" max="100" value="11.421633388781615" role="progressbar" aria-hidden="true">% buffered</progress><span class="plyr__tooltip" style="left: 95.2758%;">02:58</span></div></div><button class="plyr__controls__item plyr__control" type="button" data-plyr="fullscreen"><svg class="icon--pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__sr-only">Exit fullscreen</span><span class="label--not-pressed plyr__sr-only">Enter fullscreen</span></button></div>
        `,
        settings: ['captions', 'quality', 'speed'],
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      const player = this.$refs?.plyr?.player

      if (player) {
        player.on('ready', () => {
          const mentorButton =
            player.elements.container.querySelector('.mentor-button')
          if (mentorButton) {
            mentorButton.addEventListener('click', this.openMentorsForm)
          }
        })
      }
    })
  },
  methods: {
    getYouTubeVideoID(url) {
      const regex =
        /(?:youtube\.com\/(?:embed\/|watch\?v=)|youtu\.be\/)([^&?/]+)/
      const match = url.match(regex)
      return match && match[1] ? match[1] : null
    },
    openMentorsForm() {
      if (this.userBranch !== '') {
        // eslint-disable-next-line no-undef
        const currentPageURL = window.location.href
        // eslint-disable-next-line no-undef
        window._mtm = window._mtm || []
        // eslint-disable-next-line no-undef
        window._mtm.push({
          event: 'get-in-touch-form-submission-start',
          'event-category': 'get-in-touch-form-submission',
          'event-action': `CLICK_LINK_URL - ${currentPageURL}`,
        })
      }

      this.$store.commit('global/setDialog', {
        dialog: 'contact-mentor',
        layer: true,
        props: {
          focus: {
            type: 'mentor',
            id: this.id,
            firstName: this.firstName,
            lastName: this.lastName,
          },
        },
      })
    },
  },
}
